var _circle, _circle2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderBaseProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E1E6F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9948,
    cy: 8,
    r: 4,
    fill: "#505768"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04272 19.9857C3.43679 15.5221 6.5442 14 11.9999 14C17.4253 14 20.5284 15.8815 20.9503 19.9933C18.7529 22.4522 15.5571 24 11.9999 24C8.43904 24 5.2404 22.449 3.04272 19.9857Z",
    fill: "#505768"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBaseProfile);
export default __webpack_public_path__ + "static/media/header_base_profile.1c73b535b76f052459c99186906113aa.svg";
export { ForwardRef as ReactComponent };